<template>
  <div class="fts-tabs">
    <div class="tabs-header">
      <div 
        class="tabs-selection" 
        v-for="(tab, ind) in tabs" 
        :key="`${uid}-${ind}`" 
        :class="{active: selectedIndex == ind}"
        @click="selectTab(ind)"
      >
        <slot name="title" :title="tab.title">{{tab.title}}</slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    initialTab: Number
  },
  data: () => ({
    uid: null,
    selectedIndex: 0,
    tabs: [],
  }),
  methods: {
    selectTab (i) {
      this.selectedIndex = i;
      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i);
      });
    }
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.uid = this._uid;
    this.selectTab(this.initialTab || 0);
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-tabs {
  .tabs-header {
    max-width: 100%;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: .75rem;
    background: var(--fts-gray-1);
    .tabs-selection {
      @include user-select-none;
      padding: .575rem 1rem;
      border-bottom: 2px solid transparent;
      font-size: .75rem;
      font-weight: 500;
      cursor: pointer;
      &:not(.active) {
        &:hover {
          @include theme() {
            background: rgba($color: theme-get('fts-gray-4'), $alpha: .5);
          }
        }
      }
      &.active {
        border-bottom-color: $primaryColor;
        background: rgba($color: $primaryColor, $alpha: 0.095);
        color: $primaryColor;
      }
    }
  }
}
</style>